// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1MOOZ","tab":"ProcedureTabs_tab___o6ZQ"};